import React, { useEffect, useState } from "react";
import './CustomStory.css';
import {isMobile} from "react-device-detect";

interface CustomQuoteProps {
    id: number;
    quote: string;
    body_copy: string;
    quote_first: boolean;
    title?: string;
    date_posted?: string;
}

const CustomQuote: React.FC<CustomQuoteProps> = ({
                                                     id,
                                                     quote,
                                                     body_copy,
                                                     quote_first,
                                                     title,
                                                     date_posted,
                                                 }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: windowWidth > 575 ? 'row' : 'column',
                width: windowWidth > 575 ? '70%' : '90%',
                margin: '0 auto',
                alignItems: 'flex-start', // ensures top alignment
            }}
            key={id}
        >
            {quote_first ? (
                <>
                    <div
                        style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',  marginBottom: windowWidth < 575 ? '36px' : 0  }}
                        className="quote-style"
                    >
                        <div dangerouslySetInnerHTML={{ __html: quote }} />
                    </div>

                    <div style={{ flex: 1, paddingLeft: windowWidth > 575 ? '46px' : 0, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        {(title || date_posted) && (
                            <header className="body-header" style={{marginTop: 0, paddingTop: 0}}>
                                {title && <p className="body-title" style={{textAlign: 'left'}}>{title}</p>}
                                {date_posted && <p className="body-date" style={{textAlign: 'left'}}>{date_posted}</p>}
                            </header>
                        )}
                        <div className="body-content" dangerouslySetInnerHTML={{ __html: body_copy }} />
                    </div>
                </>
            ) : (
                <>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                        {(title || date_posted) && (
                            <header className="body-header" style={{marginTop: 0, paddingTop: 0}}>
                                {title && <p className="body-title" style={{textAlign: 'left'}}>{title}</p>}
                                {date_posted && <p className="body-date" style={{textAlign: 'left'}}>{date_posted}</p>}
                            </header>
                        )}
                        <div className="body-content" style={{marginBottom: windowWidth < 575 ? '36px' : 0,}} dangerouslySetInnerHTML={{ __html: body_copy }} />
                    </div>

                    <div
                        style={{
                            flex: 1,
                            marginLeft: windowWidth > 575 ? '46px' : 0,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',

                        }}
                        className="quote-style"
                    >
                        <div dangerouslySetInnerHTML={{ __html: quote }} />
                    </div>
                </>
            )}
        </div>
    );
};

export default CustomQuote;
